<template>
  <div class="info-box" :class="{ 'info-box--transparent': transparent }">
    <v-icon :color="iconColor" size="17.5" class="mr-2">
      {{ icon }}
    </v-icon>
    <div>
      <span v-if="isHtml" v-html="text"></span>
      <span v-else>
        {{ text }}
      </span>
      <a v-if="moreInfoLink" :href="moreInfoLink" target="_blank">{{
        $t("message.common.moreInformations")
      }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
  props: {
    icon: {
      type: String,
      default: "mdi-information"
    },
    iconColor: {
      type: String,
      default: "accent"
    },
    isHtml: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    moreInfoLink: {
      type: String,
      default: ""
    },
    transparent: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.info-box {
  display: flex;
  align-items: center;
  padding: $spacing * 1.1875 $spacing * 1.5;
  border-radius: 8px;
  background-color: $light-4;
  @include font-size(12px);
  line-height: 17px;
  font-weight: 400;

  &--transparent {
    background: transparent;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
